const state = {
    stepState: 0,
    steps: [
        {
            current: true,
            done: false,
            headerTitle: 'Select staff configuration',
            headerSubtitle: 'Select staff configuration policy to use for',
            buttonTitle: 'Staff Configuration'
        },
        {
            current: false,
            done: false,
            headerTitle: 'Set up career information',
            headerSubtitle: 'Enter career details for',
            buttonTitle: 'Career Information'
        },
        {
            current: false,
            done: false,
            headerTitle: 'Set up compensation',
            headerSubtitle: 'Enter compensation for',
            buttonTitle: 'Compensation'
        },
        {
            current: false,
            done: false,
            headerTitle: 'Set up contracts',
            headerSubtitle: 'Enter compensation for this applicant',
            buttonTitle: 'Contracts'
        },
        {
            current: false,
            done: false,
            headerTitle: 'Finishing up',
            headerSubtitle: 'Please review your entered details before sending to applicant',
            buttonTitle: 'Finishing up'
        }
    ]
};

const mutations = {
    setStepState(state, stepState) {
        state.stepState = stepState;
    },

    setStepDone(state, index) {
        state.steps[index].done = true;
    },

    setStepCurrent(state, index) {
        state.steps.forEach((step, i) => {
            step.current = i === index;
        });
    },

    nextStep(state) {
        if (state.stepState < state.steps.length - 1) {
            state.steps[state.stepState].done = true;
            state.steps[state.stepState].current = false;
            state.stepState += 1;
            state.steps[state.stepState].current = true;
        }
    },

    previousStep(state) {
        if (state.stepState > 0) {
            state.steps[state.stepState].current = false;
            state.stepState -= 1;
            state.steps[state.stepState].current = true;
            state.steps[state.stepState].done = false;
        }
    },

    resetStepperState(state) {
        state.stepState = 0;
        state.steps.forEach(step => {
            step.current = false;
            step.done = false;
        });
        state.steps[0].current = true;
    }
};

const actions = {
    nextStep({ commit }) {
        commit('nextStep');
    },

    previousStep({ commit }) {
        commit('previousStep');
    },

    resetStepperState({ commit }) {
        commit('resetStepperState');
    }
};

const getters = {
    stepState: (state) => state.stepState,
    steps: (state) => state.steps,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
